import { render, staticRenderFns } from "./SaleLayoutEditor.vue?vue&type=template&id=2b99ae3a&scoped=true"
import script from "./SaleLayoutEditor.vue?vue&type=script&lang=ts"
export * from "./SaleLayoutEditor.vue?vue&type=script&lang=ts"
import style0 from "./SaleLayoutEditor.vue?vue&type=style&index=0&id=2b99ae3a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b99ae3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b99ae3a')) {
      api.createRecord('2b99ae3a', component.options)
    } else {
      api.reload('2b99ae3a', component.options)
    }
    module.hot.accept("./SaleLayoutEditor.vue?vue&type=template&id=2b99ae3a&scoped=true", function () {
      api.rerender('2b99ae3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/SaleLayoutEditor.vue"
export default component.exports